import { StyleSheet } from 'react-native';

export const getSportIconStyles = (size: number) => StyleSheet.create({
  icon: {
    width: size,
    height: size,
  },
  fallback: {
    width: size,
    height: size,
    alignItems: 'center',
    justifyContent: 'center',
  },
  fallbackGlyph: {
    // Emoji render tall; trim slightly so the glyph occupies the same box as the image.
    fontSize: Math.round(size * 0.85),
    lineHeight: size,
    textAlign: 'center',
  },
});
